export default "__VITE_ASSET__DpvJQazp__"